import { render, staticRenderFns } from "./pop-home.vue?vue&type=template&id=0391da60&scoped=true&"
import script from "./pop-home.vue?vue&type=script&lang=js&"
export * from "./pop-home.vue?vue&type=script&lang=js&"
import style0 from "./pop-home.vue?vue&type=style&index=0&id=0391da60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0391da60",
  null
  
)

export default component.exports